import React from 'react';
import './FaceEdit.scss';
import { connect } from 'react-redux';
import PageHelper from 'Flow2/components/Article/Helpers/PageHelper';
import CustomPopUp from 'Flow2/components/Article/Utilities/PopUp/PopUp';
import { injectIntl } from 'react-intl';
import { faSmile } from '@fortawesome/free-solid-svg-icons';
import * as actions from "store/actions/index";
import Spinner from 'Flow2/components/UI/Spinner/Spinner';

class FaceEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            requiredObj: {},
            data: [],
            current: {}
        }
    }

    getBodyClasses = () => "custom-body custom-mt10";

    onCloseBtnClick = () => {
        const { faceEdit } = this.props.faceObjects;
        this.props.updatePopUpObjects({
            [`${this.props.subObjName}`]: { ...faceEdit, showOverlay: false },
            showPreview: false
        });

        if (this.props.cancelCallback) this.props.cancelCallback();
    }


    onSelectFace = (subject) => {
        this.initData(subject);
    }


    onChangeHandler = (e) => {
        const { current } = this.state;
        this.setState({ current: { ...current, subject: e.target.value } });
    }

    isNotEmpty = () => {
        const { faceSubjects } = this.props.faceObjects;
        if (faceSubjects && faceSubjects.subjects && faceSubjects.subjects.length) return true;
        return false;
    }

    onConfirmClick = () => {
        const { faceSubjects } = this.props.faceObjects;
        const { current } = this.state;

        if (this.isNotEmpty()) {
            const from = faceSubjects.subjects.find(item => item.id == current.id);
            if (from && from.subject) {
                this.props.renameSubject({ from: from.subject, to: current.subject, current });
            }
        }

        this.onCloseBtnClick();
    }

    showEditForm = () => {
        return (
            <div className="faceedit-formgroup">
                <input className="faceedit-forminput" type="text"
                    value={this.state.current.subject} onChange={this.onChangeHandler} />
            </div>
        )
    }

    displayPopUp = () => {
        return (<CustomPopUp titleIntl={this.props.titleIntl}
            contentItems={this.state.data} requiredObj={this.state.requiredObj} customIcon={faSmile}
            mainObj={this.props.faceObjects} mainObjName={this.props.mainObjName} subObjName={this.props.subObjName}
            updatePopUpObjects={this.props.updateFaceObjects} confirmCallback={this.onConfirmClick}>
            {this.showEditForm()}
        </CustomPopUp>)
    }

    componentDidUpdate(prev) {
        if (this.props.current != prev.current) {
            this.setState({ current: this.props.current });
        }
    }

    componentDidMount() {
        this.setState({ current: this.props.current });
    }

    componentWillUnmount() {
        this.onCloseBtnClick();
    }

    render() {
        return (
            <div className="FaceEdit" onClick={PageHelper.onPopUpClick}>
                {this.props.mainObj[`${this.props.subObjName}`].showOverlay ?
                    <div className="custom-overlay">
                        <div className="custom-preview">
                            {this.props.loading ?
                                <div className="custom-spinner-overlay"><Spinner /></div>
                                : <div />}
                            {this.displayPopUp()}
                        </div>
                    </div> : null}
            </div>
        );
    }
}

const mapStateToprops = (state) => ({
    faceObjects: state.face.faceObjects,
    loading: state.face.loading
})
const mapDispatchToProps = (dispatch) => ({
    updateFaceObjects: (obj) => dispatch(actions.updateFaceObjects(obj)),
    renameSubject: (obj) => dispatch(actions.renameSubject(obj))
})

export default connect(mapStateToprops, mapDispatchToProps)(injectIntl(FaceEdit));